<app-toast></app-toast>
<app-delete-confirmation-dialog title="{{ 'admin.delete_agent' | transloco }}"
    body="{{ 'admin.delete_agent_body' | transloco }}"></app-delete-confirmation-dialog>
<app-create-sales-agent-dialog
    [reloadAgentsCallbackFunction]="reloadAgentsCallbackFunction"></app-create-sales-agent-dialog>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="1"></app-admin-navigation>
    </div>

    <!--Sales agents-->
    <div class="w-full h-full border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'admin.sales_agents'
                    | transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <!--Content-->
        <div class="w-full flex flex-col gap-2 p-5">
            <div class="w-full flex justify-end items-center">
                <div class="min-w-[300px] h-[50px] px-2">
                    <app-custom-button buttonText="{{ 'admin.add_agent' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                        hoverBackgroundColor="hover:bg-primary-1200" hoverBorderColor="hover:border-pribg-primary-1200"
                        trailingIcon="assets/icons/upload.svg" (click)="createAgent()">
                    </app-custom-button>
                </div>
            </div>
            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen h-full block min-h-[500px] rounded-[16px]">
                <table class="table w-full">
                    <!-- Header -->
                    <thead class="bg-secondary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.name' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.email' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.contact_number' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal flex gap-2 items-center">{{ 'admin.url' |
                                transloco }}
                                <!-- Street input -->
                                <div class="min-w-[250px]">
                                    <app-labeled-input [inputId]="'promotion_code'"
                                        [inputType]="'text'" [(inputValue)]="promotionCodeInput" [errorMessage]="promotionCodeInputError"
                                        placeholder="{{ 'admin.promotion_code' | transloco }}" autoMarginTop="mt-0"></app-labeled-input>
                                </div>
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'archive.overview.action' | transloco }}</th>
                        </tr>
                    </thead>

                    <!-- Content -->
                    <tbody>
                        <ng-container *ngFor="let agent of salesAgents; let i = index">
                            <tr class="max-h-[50px]">
                                <td class="border-b border-border px-4 py-4">{{ agent.name }}</td>
                                <td class="border-b border-border px-4 py-4">{{ agent.email }}</td>
                                <td class="border-b border-border px-4 py-4">{{ agent.contact_number }}</td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 flex-wrap items-center">
                                        {{ generateUrl(agent) }}
                                        <button title="{{ 'admin.copy' | transloco }}"
                                            (click)="copyText(generateUrl(agent))">
                                            <img src="assets/icons/copy.svg" class="w-[24px] h-[24px]"
                                                alt="{{ 'admin.copy' | transloco }}">
                                        </button>
                                    </div>
                                </td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 items-center">
                                        <button (click)="deleteSalesAgent(agent.id)"
                                            title="{{ 'shared.delete' | transloco }}">
                                            <svg width="24" height="24" viewBox="0 0 50 50"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="25" cy="25" r="24" fill="#FF0000" />

                                                <image href="assets/icons/delete.svg" x="12" y="12" height="25px"
                                                    width="25px" />
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>

                        <tr *ngIf="salesAgents.length > 0 && !loadMoreHiddenSalesAgents">
                            <td colspan="4">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadSalesAgentsNewPage()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>